<template>
  <section>
    <ThankYouHero header="FORGOT PASSWORD"
                  paragraph="Request received! If your email address is associated with an existing Sun Heroes account, you will receive an email with a link to reset your password shortly."
                  image="Super-Steph-SunHero-300-V1" sunheroClass="sunheroimage"/>
  </section>
</template>
<script>
import ThankYouHero from '../thanks/ThankYouHero.vue'

export default {
  components: {
    ThankYouHero
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

.sunheroimage {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 2%;
  left: 70%;
  width: 50% !important;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    top: 40%;
    left: 35%;
    justify-content: center;
  }

  img {
    width: 100%;
    object-fit: contain;
  }
}

.hero-thanks {
  .sunheroimage {
    display: flex;
    justify-content: flex-end;
    position: absolute;
    top: 2%;
    left: 70%;
    width: 50% !important;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      top: 40%;
      left: 35%;
      justify-content: center;
    }

    img {
      width: 100%;
      object-fit: contain;
    }
  }
}
</style>
